import { render, staticRenderFns } from "./RoundedFacebookIcon.vue?vue&type=template&id=e640c5e8"
import script from "./RoundedFacebookIcon.vue?vue&type=script&lang=js"
export * from "./RoundedFacebookIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports